import type { FireflyRuntime } from "@squide/firefly";
import { registerLazyI18nextInstance } from "../../i18n/registerLazyI18nextInstance.ts";

export const scopeI18NextInstanceKey = "scope-module";

export function initScopeI18next(runtime: FireflyRuntime) {
    registerLazyI18nextInstance(runtime, scopeI18NextInstanceKey, {
        "en-US": async () => (await import("./en.ts")).en,
        "fr-CA": async () => (await import("./fr.ts")).fr
    });
}
